module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    attrs: {
      "transform": "translate(5000, 182), scale(-0.73, 0.73)"
    }
  }, [_c('g', {
    class: _vm.data,
    attrs: {
      "id": "boy3"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22.4771917,265.561186 C22.4506777,268.970962 20.6361973,271.007148 18.1160023,275.030666 C15.1755579,279.725116 15.5232328,288.136568 12.2646975,295.24951 C13.2070861,296.883351 18.8255119,293.801228 19.968414,290.94335 C21.1113161,288.085471 21.9778482,285.763173 22.3745769,285.040171 C22.7713055,284.317168 23.7597135,284.366816 24.0621274,285.04948 C24.3645414,285.732143 25.1402988,310.554416 25.7613093,311.770799 C26.3823198,312.987181 29.8183589,313.030417 30.410544,311.770799 C31.0027291,310.511181 30.9223214,290.871567 31.2123455,290.345916 C31.5023695,289.820265 32.2576458,290.073264 32.5764952,290.345916 C32.8953447,290.618567 32.3453863,311.598271 32.8584279,312.37899 C33.3714696,313.159709 36.9200289,313.024418 37.303862,312.37899 C37.687695,311.733563 37.8194322,290.820677 38.2052881,290.345916 C38.5911439,289.871154 39.3729699,289.924319 39.6928308,290.345916 C40.0126916,290.767512 39.1398381,310.905678 39.6928308,311.770799 C40.2458234,312.63592 43.6864139,312.649573 44.0029877,311.770799 C44.3195614,310.892024 45.0219911,290.640082 45.3552532,290.345916 C45.6885154,290.05175 46.1368263,290.079263 46.4544115,290.345916 C46.7719967,290.612568 47.1080403,305.738534 47.6569873,306.560627 C48.2059343,307.382719 50.8098294,307.576968 51.1936624,306.560627 C51.5774955,305.544285 50.2783428,267.607474 50.3294487,265.561186 C50.4997622,258.741797 48.1796239,251.484712 37.1697315,251.488469 C26.159839,251.492225 22.5341285,258.238976 22.4771917,265.561186 Z",
      "id": "boy3_right_hand",
      "fill": "#94B96B",
      "transform": "translate(31.764698, 282.201730) rotate(7.000000) translate(-31.764698, -282.201730) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40.243367,219.076796 L40.243367,219.076796 L40.243367,219.076796 C47.9751426,219.076796 54.2429851,225.344638 54.2429851,233.076414 L54.2429851,267.076453 L54.2429851,267.076453 C54.2429851,274.808228 47.9751426,281.076071 40.243367,281.076071 L40.243367,281.076071 L40.243367,281.076071 C32.5115915,281.076071 26.243749,274.808228 26.243749,267.076453 L26.243749,233.076414 L26.243749,233.076414 C26.243749,225.344638 32.5115915,219.076796 40.243367,219.076796 Z",
      "id": "boy3_right_arm_bottom",
      "fill": "#94B96B",
      "transform": "translate(40.243367, 250.076433) rotate(7.000000) translate(-40.243367, -250.076433) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy3_right_arm_top",
      "fill": "#94B96B",
      "transform": "translate(47.067715, 194.493443) rotate(7.000000) translate(-47.067715, -194.493443) ",
      "x": "33.0677153",
      "y": "141.493443",
      "width": "28",
      "height": "106",
      "rx": "14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.1144489,141.679789 L50.1144489,141.679789 L50.1144489,141.679789 C59.8577432,141.679789 67.8796852,149.339446 68.3296351,159.072345 L70.1144489,197.679789 L30.1144489,197.679789 L31.8992627,159.072345 L31.8992627,159.072345 C32.3492125,149.339446 40.3711546,141.679789 50.1144489,141.679789 Z",
      "id": "boy3_right_sleeve",
      "fill": "#94B96B",
      "transform": "translate(50.114449, 169.679789) rotate(7.000000) translate(-50.114449, -169.679789) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy3_right_sock",
      "fill": "#6D8C4A",
      "x": "46",
      "y": "382",
      "width": "30",
      "height": "36"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.5922852,427.157715 C23.3631002,426.018416 34.71875,418.661133 43.7983398,412.202148 C49.8178711,414.012695 70.0649414,414.165527 76,412.202148 C78.7573709,411.289982 81.1689453,410.269043 81.8217773,413.611816 C82.2569987,415.840332 80.3164063,417.25179 76,417.846191 L76,444 L4,444 C3.10720859,435.308164 7.97130365,429.694069 18.5922852,427.157715 Z",
      "id": "boy3_right_shoe_5",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.5922852,426.157715 C22.3575308,425.011608 41.7875977,412.54248 42.7983398,411.202148 C43.809082,409.861816 44.0957031,404.741211 44.9946289,395.291016 C46.7397461,393.128906 55.6391602,392.476562 57.1020508,395.939453 C58.5649414,399.402344 56.2827148,406.041181 52.6015625,412.515137 C48.9204102,418.989092 33.3632812,427.405273 27.3027344,429.595703 C21.2421875,431.786133 14.1113281,428.905762 17.5922852,426.157715 Z",
      "id": "boy3_right_shoe_4",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy3_right_shoe_3",
      "fill": "#94B96B",
      "points": "37.1787109 415.150513 41.4083252 412.248535 48.2275391 419.509033 43.9377441 422.847168"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy3_right_shoe_2",
      "fill": "#94B96B",
      "points": "26.1787109 422.150513 30.4083252 419.248535 37.2275391 426.509033 32.9377441 429.847168"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy3_right_shoe_1",
      "fill": "#80A259",
      "cx": "68.5",
      "cy": "429.5",
      "r": "6.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61,321 L61,321 L61,321 C69.2842712,321 76,327.715729 76,336 L76,382 L46,382 L46,336 L46,336 C46,327.715729 52.7157288,321 61,321 Z",
      "id": "boy3_right_leg_bottom",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.3846154,236 L63.3846154,236 L63.3846154,236 C75.8747474,236 86,246.125253 86,258.615385 L86,346 L37,346 L39.9947525,258.602119 L39.9947525,258.602119 C40.4267095,245.996028 50.7711255,236 63.3846154,236 Z",
      "id": "boy3_right_leg_top",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy3_left_sock",
      "fill": "#6D8C4A",
      "x": "99",
      "y": "382",
      "width": "30",
      "height": "36"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.5922852,427.157715 C76.3631002,426.018416 87.71875,418.661133 96.7983398,412.202148 C102.817871,414.012695 123.064941,414.165527 129,412.202148 C131.757371,411.289982 134.168945,410.269043 134.821777,413.611816 C135.256999,415.840332 133.316406,417.25179 129,417.846191 L129,444 L57,444 C56.1072086,435.308164 60.9713036,429.694069 71.5922852,427.157715 Z",
      "id": "boy3_left_shoe_5",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.5922852,426.157715 C75.3575308,425.011608 94.7875977,412.54248 95.7983398,411.202148 C96.809082,409.861816 97.0957031,404.741211 97.9946289,395.291016 C99.7397461,393.128906 108.63916,392.476562 110.102051,395.939453 C111.564941,399.402344 109.282715,406.041181 105.601563,412.515137 C101.92041,418.989092 86.3632812,427.405273 80.3027344,429.595703 C74.2421875,431.786133 67.1113281,428.905762 70.5922852,426.157715 Z",
      "id": "boy3_left_shoe_4",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy3_left_shoe_3",
      "fill": "#94B96B",
      "points": "90.1787109 415.150513 94.4083252 412.248535 101.227539 419.509033 96.9377441 422.847168"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy3_left_shoe_2",
      "fill": "#94B96B",
      "points": "79.1787109 422.150513 83.4083252 419.248535 90.2275391 426.509033 85.9377441 429.847168"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy3_left_shoe_1",
      "fill": "#80A259",
      "cx": "111.5",
      "cy": "429.5",
      "r": "6.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M114,321 L114,321 L114,321 C122.284271,321 129,327.715729 129,336 L129,382 L99,382 L99,336 L99,336 C99,327.715729 105.715729,321 114,321 Z",
      "id": "boy3_left_leg_bottom",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.615385,236 L110.615385,236 L110.615385,236 C123.228874,236 133.57329,245.996028 134.005247,258.602119 L137,346 L88,346 L88,258.615385 L88,258.615385 C88,246.125253 98.1252526,236 110.615385,236 Z",
      "id": "boy3_left_leg_top",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40.2354706,236 L134.010498,236 L134.010498,269 L134.010498,269 C134.010498,276.179702 128.1902,282 121.010498,282 L53.2354706,282 L53.2354706,282 C46.0557689,282 40.2354706,276.179702 40.2354706,269 L40.2354706,236 Z",
      "id": "boy3_hip",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.0350057,148.247545 C56.4808828,128.225843 116.298828,129.118639 122.658203,148.247545 C129.017578,167.376451 136.986328,257.361328 135.650391,259.462891 C123.769809,278.152226 47.5302734,271.717773 38.7695313,262.261719 C35.0181881,258.212643 45.0350057,159.003404 49.0350057,148.247545 Z",
      "id": "boy3_torso",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M112.212494,266.278948 C112.18598,269.688724 110.3715,271.724909 107.851305,275.748428 C104.91086,280.442878 105.258535,288.854329 102,295.967272 C102.942389,297.601113 108.560814,294.51899 109.703716,291.661112 C110.846619,288.803233 111.713151,286.480935 112.109879,285.757932 C112.506608,285.034929 113.495016,285.084578 113.79743,285.767241 C114.099844,286.449905 114.875601,311.272178 115.496612,312.488561 C116.117622,313.704943 119.553661,313.748179 120.145846,312.488561 C120.738032,311.228943 120.657624,291.589329 120.947648,291.063677 C121.237672,290.538026 121.992948,290.791026 122.311798,291.063677 C122.630647,291.336329 122.080689,312.316033 122.59373,313.096752 C123.106772,313.877471 126.655331,313.742179 127.039164,313.096752 C127.422997,312.451324 127.554735,291.538439 127.940591,291.063677 C128.326446,290.588916 129.108272,290.642081 129.428133,291.063677 C129.747994,291.485274 128.875141,311.62344 129.428133,312.488561 C129.981126,313.353682 133.421716,313.367335 133.73829,312.488561 C134.054864,311.609786 134.757294,291.357843 135.090556,291.063677 C135.423818,290.769511 135.872129,290.797025 136.189714,291.063677 C136.507299,291.33033 136.843343,306.456296 137.39229,307.278389 C137.941237,308.100481 140.545132,308.29473 140.928965,307.278389 C141.312798,306.262047 140.013645,268.325236 140.064751,266.278948 C140.235065,259.459559 137.914926,252.202474 126.905034,252.20623 C115.895141,252.209987 112.269431,258.956738 112.212494,266.278948 Z",
      "id": "boy3_left_hand",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.000382,219.000725 L126.000382,219.000725 L126.000382,219.000725 C133.732158,219.000725 140,225.268567 140,233.000343 L140,267.000382 L140,267.000382 C140,274.732158 133.732158,281 126.000382,281 L126.000382,281 L126.000382,281 C118.268606,281 112.000764,274.732158 112.000764,267.000382 L112.000764,233.000343 L112.000764,233.000343 C112.000764,225.268567 118.268606,219.000725 126.000382,219.000725 Z",
      "id": "boy3_left_arm_bottom",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy3_left_arm_top",
      "fill": "#94B96B",
      "x": "112",
      "y": "141",
      "width": "28",
      "height": "106",
      "rx": "14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126,141 L126,141 L126,141 C135.743294,141 143.765236,148.659657 144.215186,158.392556 L146,197 L106,197 L107.784814,158.392556 L107.784814,158.392556 C108.234764,148.659657 116.256706,141 126,141 Z",
      "id": "boy3_left_sleeve",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.8118947,127.432135 C73.6289702,132.692337 73.9485497,134.790975 71.6132812,137.684326 C72.2113804,138.794322 75.1022125,146.539062 82,146.539062 C88.8977875,146.539062 95.4289344,140.198106 96.625,137.684326 C94.5101819,134.720292 94.124737,133.309517 95.3803075,127.432135 C93.8200709,123.191465 74.9905604,123.333451 72.8118947,127.432135 Z",
      "id": "boy3_neck",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.867739,92.2781332 C124.993591,91.0286828 128.045468,89.4414308 131.505655,92.2781332 C134.465349,94.7045257 132.240559,104.223525 128.248047,109.495117 C124.293374,114.716748 117.860356,115.800859 115.335309,113.799363 C110.716797,125.638672 92.0969171,131.452589 80,131.149414 C58.4130859,130.608398 43.5214844,109.495117 44.9140625,87.5419763 C46.951853,55.4174583 63.3657664,40.5292969 84.9239385,40.5292969 C104.273712,40.4240884 128.184996,53.9697132 122.867739,92.2781332 Z",
      "id": "boy3_face",
      "fill": "#94B96B",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "boy3_mouth_bottom"
    }
  }, [_c('path', {
    attrs: {
      "d": "M73.374402,124.059347 C74.8117861,124.059347 87.290894,124.059347 88.8967286,124.059347 C90.5025632,124.059347 84.7414706,121.021439 79.565732,121.021439 C74.3899935,121.021439 71.9370178,124.059347 73.374402,124.059347 Z",
      "fill": "#80A259",
      "transform": "translate(81.069498, 122.540393) scale(1, -1) translate(-81.069498, -122.540393) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.4506281,120.021439 C73.2473583,120.021439 88.8462431,120.021439 90.8535363,120.021439 C92.8608295,120.021439 85.6594638,115.970896 79.1897906,115.970896 C72.7201174,115.970896 69.6538979,120.021439 71.4506281,120.021439 Z",
      "id": "boy3_mouth_top",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M76.1446155,89.8218042 C76.1446155,87.4957211 82.1301319,87.29188 82.1330733,89.8218042 C82.1360147,92.3517283 84.0579453,105.552867 82.1360147,107.898658 C80.2140842,110.244448 74.5643321,109.458498 73.689992,107.898658 C72.8156518,106.338817 76.1446155,92.1478872 76.1446155,89.8218042 Z",
      "id": "boy3_nose",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.0872659,92.2884047 C67.272062,85.7276872 54.7518133,84.726412 52.8702819,90.4076988 C52.8613497,98.0792479 68.0407525,98.756829 70.0872659,92.2884047 Z",
      "id": "boy3_right_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy3_right_pupil",
      "fill": "#6D8C4A",
      "cx": "58.630893",
      "cy": "92.1502898",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88.304246,92.2884047 C91.1194499,85.7276872 103.639699,84.726412 105.52123,90.4076988 C105.530162,98.0792479 90.3507595,98.756829 88.304246,92.2884047 Z",
      "id": "boy3_left_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy3_left_pupil",
      "fill": "#6D8C4A",
      "cx": "94.064861",
      "cy": "92.1502898",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.9651236,83.0973966 C69.4247445,80.3810949 52.3650421,80.3383442 52.0226901,82.7648379 C51.6803381,85.1913316 55.2532176,84.034359 59.9555231,84.4986219 C64.6578285,84.9628848 70.5055028,85.8136984 69.9651236,83.0973966 Z",
      "id": "boy3_right_brow",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88.0348764,83.0973966 C88.5752555,80.3810949 105.634958,80.3383442 105.97731,82.7648379 C106.319662,85.1913316 102.746782,84.034359 98.0444769,84.4986219 C93.3421715,84.9628848 87.4944972,85.8136984 88.0348764,83.0973966 Z",
      "id": "boy3_left_brow",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.49941,63.3388672 C99.1914062,45.7265625 105.568199,83.8065438 115.156682,101.09056 C116.177536,99.1563661 116.80006,96.2862719 117.024253,92.4802773 C119.110729,97.3948995 121.551296,100.687118 124.345954,102.356934 C124.345954,97.939167 124.345954,94.2748794 124.345954,91.505249 C125.559452,94.942171 129.115344,98.4917183 134.025384,101.09056 C132.030383,96.0329972 132.186523,88.4511857 132.186523,82.9589844 C132.186523,77.4667831 128.261719,22.3964844 79.49941,38.328125 C33.1074219,35.40625 44.7167969,90.3222656 41.0429688,102.356934 C51.9638672,93.765625 51.6230469,45.7363281 77.49941,63.3388672 Z",
      "id": "boy3_hair",
      "fill": "#6D8C4A"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543bad26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/boy3.vue
// module id = 715
// module chunks = 1